var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterLipActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 74,
    viewBox: "0 0 103 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 44.7984L51.8552 73.4922L-1.37551e-05 44.7984L-1.14332e-05 0.48828L103 0.488281L103 44.7984Z",
    fill: "#007FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterLipActive);
export default __webpack_public_path__ + "static/media/letter-lip-active.c5bc431a5dbd90d871a1165084b4b4e9.svg";
export { ForwardRef as ReactComponent };